import type { StoreApi, UseBoundStore } from 'zustand';

import { createZustandStore } from '../createZustandStore';
import type {
  IBillingInfoFormSlice,
  IOrderSummarySlice,
  IPayflowProgressBarSlice,
  IPaymentButtonSlice,
  IPaymentMethodsSlice,
  IAlertSlice,
  IPromoCodesSlice,
  IInboundPromoCodesSlice,
  IEmailPlansSlice,
  IAddOnsSlice,
  IPrepaySelectSlice,
  IContactsTierSelectSlice,
  ICurrencySlice,
  INonProfitSlice,
  IPaymentProcessingInfoSlice,
  IPayflowTopBarSlice,
  IScheduledDowngradeBannerSlice,
} from '../slices';
import {
  createBillingInfoFormSlice,
  createOrderSummarySlice,
  createPayflowProgressBarSlice,
  createPaymentButtonSlice,
  createPaymentMethodsSlice,
  createAlertSlice,
  createPromoCodesSlice,
  createInboundPromoCodesSlice,
  createEmailPlansSlice,
  createAddOnsSlice,
  createPrepaySelectSlice,
  createContactsTierSelectSlice,
  createCurrencySlice,
  createNonProfitSlice,
  createPaymentProcessingInfoSlice,
  createPayflowTopBarSlice,
  createScheduledDowngradeBannerSlice,
} from '../slices';

export type IPayflowPageStore = IBillingInfoFormSlice &
  IOrderSummarySlice &
  IPayflowProgressBarSlice &
  IPaymentButtonSlice &
  IPaymentMethodsSlice &
  IPrepaySelectSlice &
  ICurrencySlice &
  INonProfitSlice &
  IContactsTierSelectSlice &
  IAlertSlice &
  IPromoCodesSlice &
  IInboundPromoCodesSlice &
  IEmailPlansSlice &
  IAddOnsSlice &
  IPaymentProcessingInfoSlice &
  IPayflowTopBarSlice &
  IScheduledDowngradeBannerSlice;

export const usePayflowPageStore = createZustandStore(
  createBillingInfoFormSlice,
  createOrderSummarySlice,
  createPayflowProgressBarSlice,
  createAlertSlice,
  createPaymentButtonSlice,
  createPaymentMethodsSlice,
  createPrepaySelectSlice,
  createCurrencySlice,
  createNonProfitSlice,
  createContactsTierSelectSlice,
  createPromoCodesSlice,
  createInboundPromoCodesSlice,
  createEmailPlansSlice,
  createAddOnsSlice,
  createPaymentProcessingInfoSlice,
  createPayflowTopBarSlice,
  createScheduledDowngradeBannerSlice
);

export type PayflowPageStore = UseBoundStore<StoreApi<IPayflowPageStore>>;
